module.exports = __webpack_public_path__ + "img/elec-design.197a6ef9.jpg";